import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SuccessModal from "../../utils/SuccessModal";

const AskQuery = () => {
  const navigate = useNavigate();
  const { tenderId } = useParams();
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [query, setQuery] = useState();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setQuery({ ...query, [e.target.name]: e.target.value });
  };

  const handleSubmitQuery = async () => {
    setIsLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/query`,
        {
          vendorId: vendorId,
          tenderId: tenderId,
          title: query.title,
          body: query.body,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setOpen(true);
    } catch (error) {
      console.error("Error updating tender status:", error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div style={{ position: "relative" }}>
      {isLoading && <div className="loading-div"></div>}
      <Typography variant="h4">Query</Typography>
      <Box className="dashboard-container" px={10}>
        <label htmlFor="title">Title</label>
        <input type="text" name="title" id="title" onChange={handleChange} />
        <label htmlFor="body">Body</label>
        <textarea
          name="body"
          id="body"
          rows={8}
          onChange={handleChange}
        ></textarea>
      </Box>
      <Box className="btn-container" sx={{gap: 5}}>
        <Button
          className="btn-outlined"
          onClick={() => navigate(`/vendor/dashboard/${tenderId}`)}
        >
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleSubmitQuery}
          disabled={isLoading}
        >
          {isLoading ? "Submitting..." : "Submit Query"}
        </Button>
      </Box>

      <SuccessModal
        open={open}
        handleClose={() => setOpen(false)}
        msg={"Query submitted."}
        nav={`/vendor/dashboard/${tenderId}/view-query`}
      />
    </div>
  );
};

export default AskQuery;
